/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "local 0.1.0",
    versionChannel: "local",
    buildDate: "2026-05-25T10:50:27.938Z",
    commitHash: "e3c2645ea157315dff64c6a525f2c4ae50ff4e83",
};
